import CourseBanner from './CourseBanner.gql';

export default CourseBanner;
